module.exports = __webpack_public_path__ + "static/img/phb2.a0d8bd20.png";